import { render, staticRenderFns } from "./DragDropFileUploadComponent.vue?vue&type=template&id=2f4f4dd0&"
import script from "./DragDropFileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./DragDropFileUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./DragDropFileUploadComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports